import * as components from './components';
export * from './components';
export var DesignSystem = {
  install(Vue) {
    Object.entries(components).forEach(_ref => {
      var [name, c] = _ref;
      Vue.component(name, c);
    });
  }

};